<template>
  <div class='map-lpo'>
    <!-- <button @click='test'>test</button> -->
    <div id='map-lpo-test'>
     
    </div>
   
  </div>
</template>

<script>
  import 'ol/ol.css';
  import XYZ from 'ol/source/XYZ';
  import {Map, View} from 'ol';
  // import Tile from 'ol/layer/Tile';
  // import OSM from 'ol/source/OSM';
  import Control from 'ol/control/Control';
  import {defaults} from 'ol/control';
  // import source from 'ol/source';

  import {useGeographic} from 'ol/proj';

  import Feature from 'ol/Feature';
  import GeoJSON from 'ol/format/GeoJSON';
  import WKT from 'ol/format/WKT';
  import Circle from 'ol/geom/Circle';
  import {Point, MultiPoint} from 'ol/geom';
  import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
  import {OSM, Vector as VectorSource} from 'ol/source';
  import {Circle as CircleStyle, Fill, Stroke, Style, Text} from 'ol/style';
  import { mapState } from "vuex";
  export default {
    name: 'map-lpo',
    props: { abrisPoints: Array, actStrips: Array, actTrack: String, lpoGeoms: Array },
    data() {
      return {
        map: null,
        abrisLayer: null,
        probaLayer: null,
        trackLayer: null
      }
    },

    watch: {
      lpoGeoms() {
        this.updateLpoGeoms()
      },
      actTrack() {
        this.updateTrack()
      },
      abrisPoints(pointList) {
        this.updateMap()
      },
      actStrips() {
        //console.log(this.actStrips)
        this.updateStrips()
      },
      plotList() {
        //this.updateProba()
        //console.log(this.plotList, this.selectedLpo.inspection_type_id)
      }
      
    },
    computed: {
      ...mapState("selectedLpo/recount", {
        plotList: (state) => state["plotList"]
      }),
      ...mapState("selectedLpo", {
        selectedLpo: (state) => state.lpo,
      }),
    },
    beforeDestroy() {
      this.map = null
      this.abrisLayer = null
      this.probaLayer = null
      this.trackLayer = null
      this.lpoGeomsLayer = null
    },
    methods: {
      updateLpoGeoms() {
        if (this.lpoGeoms) {
          useGeographic();
          const features = [];
          this.lpoGeoms.forEach(feature => {
            features.push({
            'type': 'Feature',
            'geometry': {
              'type': 'Polygon',
              'coordinates': [feature]
            }}); 
          });
          var geojsonLpoGeoms = {
            'type': 'FeatureCollection',
            'crs': {
              'type': 'name',
              'properties': {
                'name': 'EPSG:4326'
              } 
            },
            'features': features
          };
          var lpoGeomsSource = new VectorSource({
            features: (new GeoJSON()).readFeatures(geojsonLpoGeoms)
          });
          this.lpoGeomsLayer.setSource(lpoGeomsSource)
          this.lpoGeomsLayer.setStyle(this.lpoGeomsStyle)
        }
      },
      updateTrack() {
        if (this.actTrack) {
          useGeographic();
          const format = new WKT();
          const feature = format.readFeature(this.actTrack, {
            //dataProjection: 'EPSG:4326',
            //featureProjection: 'EPSG:4326',
          });
          //console.log(feature)
          var trackSource = new VectorSource({
              features: [feature]
          })
          this.trackLayer.setSource(trackSource)
          this.trackLayer.setStyle(this.trackStyle)
        }
      },
      updateStrips() {
        if(this.actStrips) {
          useGeographic();
          const plots = this.actStrips.filter((item) => {return item.geom_type == 'LineString'}).map((item) => {return item.features})[0]
          const probaFeatures = [];
          if (plots) {
            plots.forEach((plot) => {
                //console.log(point)
                let s = JSON.parse(JSON.stringify(plot)).sort((a,b) => a.point_num - b.point_num)
                probaFeatures.push({
                  'type': 'Feature',
                  'geometry': {
                    'type': 'LineString',
                    'coordinates': s.map((point) => { return [point.lon, point.lat]})
                  },
                })
            })
          }
          const plot_points = this.actStrips.filter((item) => {return item.geom_type == 'Point'}).map((item) => {return item.features})[0]
          if (plot_points) {
            plot_points.forEach((plot_point) => {
              probaFeatures.push({
                  'type': 'Feature',
                  'geometry': {
                    'type': 'Point',
                    'coordinates': [plot_point.lon, plot_point.lat]
                  },
                    'properties': {
                      'num': plot_point.point_num
                    }
                })
            })
          }
          let probaGeojson = {
              'type': 'FeatureCollection',
              'crs': {
                'type': 'name',
                'properties': {
                  'name': 'EPSG:4326'
                } 
              },
              'features': probaFeatures
            }
          //console.log(probaGeojson)
          var probaSource = new VectorSource({
            features: (new GeoJSON()).readFeatures(probaGeojson)
          })
          this.probaLayer.setSource(probaSource)
          this.probaLayer.setStyle(this.probaStyle)
        }
        if (this.abrisPoints.length == 0 && isFinite(probaSource.getExtent()[0])) {
          this.map.getView().fit(probaSource.getExtent(), {size: this.map.getSize(), padding: [20, 20 , 20, 20]});
        }


          
      },
      trackStyle(feature) {
        var styles = []
          styles.push(
            new Style({
            stroke: new Stroke({
              color: "rgba(0, 0, 255, 0.4)",
              width: 1
            })
          }))
          return styles
      },
      probaStyle(feature) {
        if(feature.getGeometry().getType() == 'LineString') {
          var styles = []
          styles.push(
            new Style({
            stroke: new Stroke({
              color: "black",
              width: 2
            })
          }))
        feature
          .getGeometry()
          .getCoordinates()
          .forEach(function(coordinates, index) {
            styles.push(
              new Style({
                image: new CircleStyle({
                  radius: 2,
                  fill: new Fill({
                    color: "yellow"
                  }),
                  stroke: new Stroke({
                    color: "black",
                    width: 1
                  })
                }),
                text: new Text({
                  font: "10px Calibri,sans-serif",
                  overflow: true,
                  fill: new Fill({
                    color: "#800080"
                  }),
                  stroke: new Stroke({
                    color: "white",
                    width: 2
                  }),
                  text: (index + 1).toString(),
                  offsetX: 6,
                  offsetY: -6
                }),
                geometry: new Point(coordinates)
              })
            );
          });
        } else if (feature.getGeometry().getType() == 'Point') {
            var styles = []
              styles.push(new Style({
                image: new CircleStyle({
                  radius: 3,
                  fill: new Fill({
                    color: 'yellow',
                  }),
                  stroke: new Stroke({
                    color: 'black',
                    width: 1,
                  }),
                }),
                text: new Text({
                      font: "10px Calibri,sans-serif",
                      overflow: true,
                      fill: new Fill({
                        color: "yellow"
                      }),
                      stroke: new Stroke({
                        color: "black",
                        width: 3
                      }),
                      text: feature.get('num').toString(),
                      //offsetX: 6,
                      offsetY: 9
                    })
              }))
        }
        return styles;
      },
      abrisStyle(feature) {
        var styles = [
          new Style({
            stroke: new Stroke({
              color: "red",
              width: 2
            }),
            fill: new Fill({
              color: "rgba(0, 0, 255, 0)"
            })
          })
        ];
        feature
          .getGeometry()
          .getCoordinates()[0]
          .forEach(function(coordinates, index) {
            styles.push(
              new Style({
                image: new CircleStyle({
                  radius: 2,
                  fill: new Fill({
                    color: "black"
                  })
                }),
                text: new Text({
                  font: "10px Calibri,sans-serif",
                  overflow: true,
                  fill: new Fill({
                    color: "#000"
                  }),
                  stroke: new Stroke({
                    color: "#fff",
                    width: 3
                  }),
                  text: (index + 1).toString(),
                  offsetX: 6,
                  offsetY: -6
                }),
                geometry: new Point(coordinates)
              })
            );
          });
        return styles;
      },
      lpoGeomsStyle(feature) {
        var styles = [
          new Style({
            stroke: new Stroke({
              color: "grey",
              width: 2,
              lineDash: [2,4]
            }),
            fill: new Fill({
              color: "rgba(0, 0, 255, 0)"
            })
          })
        ];
        return styles
      },
      updateMap() {
        useGeographic();
        const coordinates = [[]];
        this.abrisPoints.forEach(point => {
            const temp = [];
            temp[0] = point.lon;
            temp[1] = point.lat;
            coordinates[0].push(temp);
          });
          const features = [];
          features.push({
            'type': 'Feature',
            'geometry': {
              'type': 'Polygon',
              'coordinates': coordinates
            }
          });

          var geojsonObject = {
            'type': 'FeatureCollection',
            'crs': {
              'type': 'name',
              'properties': {
                'name': 'EPSG:4326'
              } 
            },
            'features': features
          };
          var vectorSource = new VectorSource({
            features: (new GeoJSON()).readFeatures(geojsonObject)
          });
          if (this.abrisPoints.length > 0) {
            //this.map.addLayer(this.vectorLayer);
            this.abrisLayer.setSource(vectorSource)
            this.abrisLayer.setStyle(this.abrisStyle)
            this.map.getView().fit(vectorSource.getExtent(), {size: this.map.getSize(), padding: [20, 20 , 20, 20]});
          } else {
            this.abrisLayer.setSource(new VectorSource())
            //this.map.getView().fit([0,50,180,60], {size: this.map.getSize()});
          }
      }
    },
    mounted() {
      const osmLayer = new TileLayer({source: new OSM({ projection: 'EPSG:3857' })});
      this.abrisLayer = new VectorLayer();
      this.probaLayer = new VectorLayer();
      this.trackLayer = new VectorLayer();
      this.lpoGeomsLayer = new VectorLayer();
      this.map = new Map({
        // controls: new Control({zoom: false, rotate: false}),
        target: 'map-lpo-test',
        controls: defaults({ attribution: false }),
        layers: [
          osmLayer,
          // yandexLayer,
          this.trackLayer,
          this.abrisLayer,
          this.lpoGeomsLayer,
          this.probaLayer,
          
        ],
        view: new View()
      });
      this.updateMap()
      this.updateLpoGeoms()
      this.updateStrips()
      this.updateTrack()
    },
  }
</script>

<style>
  .ol-zoom {
    left: unset;
    right: 8px;
  }
</style>

<style scoped>
  .map-lpo {
    /*position: absolute;*/
    /*top: 0;*/
    margin: auto;
    width: 100%;
  }

  #map-lpo-test {
    /*width: 100vw;*/
    /*height: calc(100vh - 56px);*/
    height: 400px;
  }
</style>